export default __webpack_public_path__ + "static/media/googleLogin.96fa9364.svg";